import AjaxLoad from '../../lib/ajax-load';
import { loadScript } from '../../js/helper';

class NewsletterRegisterForm {
    constructor ($newsletter, options) {
        this.$newsletter = $newsletter;
        this.$newsletterContent = $newsletter.querySelector('[data-newsletter="content"]');
        this.$newsletterForm = $newsletter.querySelector('form');
    }

    init () {
        if (this.$newsletterForm) {
            this.setEvents();
        }
    }

    initSelect () {
        const $choices = this.$newsletter.querySelector('[data-choices]');

        if ($choices) {
            import('../../components/form/form-choices.js').then(({ FormChoice }) => {
                let search = $choices.getAttribute('data-choices-search');
                search = search === 'true';

                let sort = $choices.getAttribute('data-choices-sort');
                sort = sort !== 'false';

                const $choice = new FormChoice($choices, {
                    search: search, // eslint-disable-line
                    sort: sort // eslint-disable-line
                });
                $choice.initialize();
            });
        }
    }

    initRecaptcha () {
        const $recaptcha = this.$newsletter.querySelector('[data-sitekey]');

        if ($recaptcha) {
            let scriptIsLoaded = false;

            const interval = setInterval(() => {
                if (typeof grecaptcha !== 'undefined' && $recaptcha.childElementCount > 0) {
                    scriptIsLoaded = true;
                    clearInterval(interval);
                }

                if (typeof grecaptcha !== 'undefined' && $recaptcha.childElementCount === 0) { // eslint-disable-line
                    scriptIsLoaded = true;
                    grecaptcha.render( // eslint-disable-line
                        $recaptcha
                    );
                    clearInterval(interval);
                } else {
                    if (!scriptIsLoaded) {
                        loadScript('//www.google.com/recaptcha/api.js?hl=de_DE');
                    }
                }
            }, 500);
        }
    }

    sendTrackingData () {
        window.dataLayer = window.dataLayer || [];
        const request = document.querySelector('[id="newsletter_register_request"]');

        if (request && request.value.indexOf('.') !== -1) {
            window.dataLayer.push({ // eslint-disable-line no-undef
                event: 'Newsletter',
                request: request.options[request.selectedIndex].text
            });
        }
    }

    setEvents () {
        this.$newsletterForm.addEventListener('submit', (e) => {
            e.preventDefault();
            this.sendForm(this.$newsletterForm.getAttribute('action'));
        });
    }

    sendForm (url) {
        this.$newsletterContent.classList.add('is--loading');

        const ajaxLoad = new AjaxLoad(url, {
            requestMethod: 'POST',
            requestData: new FormData(this.$newsletterForm),
            onSuccess: (result) => {
                this.setForm(result, () => {
                    this.$newsletterForm = this.$newsletter.querySelector('form');

                    if (this.$newsletterForm) {
                        this.setEvents();
                        this.initSelect();
                        this.initRecaptcha();
                    }
                });
            }
        });

        ajaxLoad.initialize();
    }

    setForm (result, callback) {
        const results = JSON.parse(result.toString());

        if (results.success) {
            this.sendTrackingData();
        }

        const template = document.createElement('div');

        if (results.html !== '') {
            template.innerHTML = results.html;
        }

        this.$newsletterContent.innerHTML = template.innerHTML;

        setTimeout(() => {
            this.$newsletterContent.classList.remove('is--loading');

            if (typeof callback === 'function') {
                callback();
            }
        }, 200);
    }
}

export { NewsletterRegisterForm };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $newsletter = $context.querySelectorAll('[data-newsletter="root"]');

        for (let i = 0; i < $newsletter.length; i++) {
            const $$newsletter = new NewsletterRegisterForm($newsletter[i]);
            $$newsletter.init();
        }
    }
});
